module.exports = __webpack_public_path__ + "img/noImg.0fca54f5.jpg";